import {ChangeDetectionStrategy, Component, ElementRef, input, output, inject, ViewChild} from '@angular/core';
import {TeamMembership} from '../../../../../types/team-management.type';
import {AuthService} from '../../../../../auth/shared/services/auth.service';
import {TeamManagementService} from '../../../../../services/api/team-management.service';
import {Router} from '@angular/router';
import {getFirstLetters} from '../../../../../common/utils/helpers';
import {CommonModule} from '@angular/common';

import {ImgCacheBusterDirective} from '../../../../../directives/img-cache-buster';

@Component({
  standalone: true,
  selector: 'mc-team-item',
  imports: [CommonModule, ImgCacheBusterDirective],
  templateUrl: './team-item.component.html',
  styleUrl: './team-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamItemComponent {
  teamManagementService = inject(TeamManagementService);
  authService = inject(AuthService);
  router = inject(Router);

  team = input<TeamMembership>();
  userId = input<string>();

  switchToTeam = output<TeamMembership>();

  @ViewChild('teamButton') private teamButton?: ElementRef<HTMLButtonElement>;

  get element(): HTMLButtonElement | undefined {
    return this.teamButton?.nativeElement;
  }

  focus(): void {
    this.teamButton?.nativeElement.focus();
  }

  get isActive() {
    return (
      this.team().myMembershipTeamOwnerAccountId === this.authService.uWTargetSwitchId ||
      (!this.authService.uWTargetSwitchId && this.team().myMembershipTeamOwnerAccountId === this.userId())
    );
  }

  getShortName(name: string) {
    return getFirstLetters(name).slice(0, 2);
  }

  onSwitchToTeam(team: TeamMembership) {
    this.switchToTeam.emit(team);
  }
}
